export default "__VITE_ASSET__ucQkjHaJ__"